import figure0 from './architecture-images/01-smart-query.png';
import figure1 from './architecture-images/02-game-factory.png';
import figure2 from './architecture-images/03-enterprise-knowledge.png';
import figure3 from './architecture-images/04-talent-mining.png';
import figure4 from './architecture-images/05-ai-lab-platform.png';
import figure5 from './architecture-images/06-latticeflow.png';
import figure6 from './architecture-images/07-bilm.png';
import figure7 from './architecture-images/08-global-recommendation.png';
import figure8 from './architecture-images/09-kol-recommendation.png';
import figure10 from './architecture-images/11-text2motion.png';
import figure11 from './architecture-images/12-carbon-policy.png';

export const projectArchitectureFigures = {
    'query': {src: figure0, title: '智能问数 Agent｜语义约束下的自助分析', caption: '以业务语义统一查询口径，按任务复杂度分流，并通过受控数据服务返回可核验结果。'},
    'gamefactory': {src: figure1, title: 'Game Factory｜约束生成与权威运行', caption: '持久控制面组织条件化定义与多角色生成，生成制品经受控入口进入权威运行，并保留数值、公平性及交付证据。'},
    'knowledge': {src: figure2, title: '企业知识库｜知识编译与证据驱动调查', caption: '生产侧发布一致的知识构建，消费侧围绕证据充分性检索、调查并生成带来源的结论。'},
    'talent': {src: figure3, title: 'Talent Mining｜岗位胜任力与行为证据评估', caption: '以岗位标准组织初评和追问，再由真实面试表现支持比较与结论；方法规则和效果验收分开。'},
    'platform': {src: figure4, title: 'AI LAB｜三大范式与共用工程体系', caption: '三大范式约束 Agent 的上下文、执行和评价；共用能力与研发 SOP 支撑多业务持续交付。'},
    'lattice': {src: figure5, title: 'LatticeFlow｜统一日志、计算与数据服务', caption: '采集与重放经统一日志进入 Flink/Rust 主链路，通过受协调的提交连接分层存储、数据服务与业务分析。'},
    'bilm': {src: figure6, title: 'BILM｜位图关系索引与增量持久化', caption: '以单向位图索引承载集合代数与反向包含判断，通过 WAL、增量快照和一致性切点支持恢复。'},
    'global-recommendation': {src: figure7, title: '全球站推荐｜状态感知与风险约束排序', caption: '聚合特征与行为序列共同驱动状态分群，经多目标排序和风险硬约束后形成推荐结果。'},
    'kol': {src: figure8, title: '达人智选｜多路召回与社交联合推荐', caption: '语义候选经相似度融合和圈层策略分配，分别服务 Feed 分发与满足关系约束的达人组合。'},
    'motion': {src: figure10, title: '星瞳 text2motion｜语义动作检索与姿态修正', caption: '自然语言先映射为动作意图，再检索并组合片段，经姿态与时序检查后进入角色动画表现。'},
    'carbon': {src: figure11, title: '碳中和政策模拟｜MDP 与因果解释', caption: '政策智能体在模拟环境中选择干预，由延迟反馈与奖励塑形引导长期权衡，并通过多场景回放解释策略。'},
};
